import { render, staticRenderFns } from "./OrginCountries.vue?vue&type=template&id=4217794f&"
import script from "./OrginCountries.vue?vue&type=script&lang=js&"
export * from "./OrginCountries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports